export default __webpack_public_path__ + "static/media/ManOnPoop.cad0ecc1.svg";